// components/global/SessionModalHost.jsx
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { closeSessionModal } from "../store/sessionModalSlice";

export default function AlarmSession() {
  const dispatch = useDispatch();
 const { visible, type, payload } = useSelector(s => s.sessionModal);

  const footer = (
    <div>
      <Button label="Zatvori" onClick={() => dispatch(closeSessionModal())} />
    </div>
  );

  const header =
    type === "SESSION_LOCK" ? "Zauzeta sesija!" :
    type === "ERROR" ? "Greška" :
    "Obaveštenje";

  return (
    <Dialog
      header={header}
      visible={visible}
      onHide={() => dispatch(closeSessionModal())}
      footer={footer}
      modal
      style={{ width: "520px" }}
    >
      {type === "SESSION_LOCK" ? (
        <div style={{ lineHeight: 1.6 }}>
          <div style={{ marginTop: 10 }}>
            {payload?.message ?? "Ovaj predmet je trenutno u radu kod drugog korisnika."}
          </div>
        </div>
      ) : (
        <div style={{ lineHeight: 1.6 }}>
          <div><b>Nalog:</b> {payload?.brojNaloga ?? payload?.nalogId ?? "-"}</div>
          <div><b>Uzeo u rad:</b> {payload?.user ?? "-"}</div>
          <div><b>Vreme:</b> {payload?.startedAt ?? "-"}</div>
          <div style={{ marginTop: 10 }}>
            {payload?.message ?? "Ovaj predmet je trenutno u radu kod drugog korisnika."}
          </div>
        </div>
      )}
    </Dialog>
  );
}
